import { Paper } from '@mui/material';
import { usePartnerExportRepairEventsApi, usePartnerFetchRepairEventsApi } from 'api/partner/repair_event';
import RepairEventTable from 'components/partner/repair_event/repair_event_table';
import { ContentHeader, ContentTitle } from 'components/shared/content';
import { SearchBar } from 'components/shared/search_bar';
import ThemedButton from 'components/shared/themed_button';
import { RepairEventSearchForm } from 'entities/repair_event';
import { useForm } from 'rac';
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
export type InstrumentRepairEventIndexProps = {};

export const RepairEventIndex: React.FC = () => {
  const searchForm = useForm<RepairEventSearchForm>({});
  const api = usePartnerFetchRepairEventsApi(searchForm);
  const exportApi = usePartnerExportRepairEventsApi(searchForm);

  useEffect(() => {
    api.execute();
  }, []);

  const handleSearch = () => {
    api.executeAndPageReset();
  };
  const handleClickExport = (format: 'xlsx') => {
    exportApi.execute(format);
  };

  return (
    <>
      <ContentHeader
        subHeader={
          <>
            <ThemedButton color="secondary" onClick={() => handleClickExport('xlsx')} style={{ marginLeft: 10 }}>
              Excel出力
            </ThemedButton>
          </>
        }
      >
        <ContentTitle title="修理履歴一覧" />
        <SearchBar<RepairEventSearchForm>
          form={searchForm}
          searchAttr="searchText"
          placeholder="機器名称・不具合箇所・不具合内容で検索"
          onSubmit={handleSearch}
        />
      </ContentHeader>
      <Paper>
        <RepairEventTable indexApi={api} showInstrument />
      </Paper>
    </>
  );
};
export default RepairEventIndex;
